import {useMemo, useState} from 'react'
import {Tooltip, Grid, Button,} from "@material-ui/core";
import Toolbar from "@material-ui/core/Toolbar";
import clsx from "clsx";
import ExcelFile from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/components/ExcelFile";
import ExcelSheet from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/elements/ExcelSheet";
import ExcelColumn from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/elements/ExcelColumn";
import {isEmpty} from "lodash";
import {lighten, makeStyles} from "@material-ui/core/styles";
import {isNotEmpty} from "../../shared/functions/types_check";
import {useInventory} from "../../context/InventoryContext";
import {Card, CardContent, Stack, Typography} from "@mui/material";
import GridOnIcon from "@material-ui/icons/GridOn";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
// import AutoFixOffIcon from '@mui/icons-material/AutoFixOff';
// import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
// import MessagePrompt from "../_customs/MessagePrompt";
// import InventoryPdfExport from "./../Inventory/InventoryPdfExport";
import useToggle from "../../shared/functions/useToggle";
import ItemsAutoComplete from "../_customs/ItemsAutoComplete";
import {useDispatch} from "react-redux";
import {getInventory, getItemInventory} from 'src/redux/slices/inventory/inventory.thunks'
import {VendorSelect} from "../../shared/components/VendorSelect"; 
import SendOrdering from '../orders/fragments/SendOrdering';
// import emailjs from '@emailjs/browser';


const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.primary.main,
                backgroundColor: lighten(theme.palette.primary.light, 0.85),
                border: 0,
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.primary.dark,
            },
    title: {
        flex: '1 1 50%',
    },
}));

export default function OrderingDataGridToolbar({numSelected, selectedItem = []}) {
    
    const dispatch = useDispatch();
    const [selected, setSelected] = useState(null)
    const {open, handleClose, handleOpen} = useToggle()
    const {open: isCreateModalOpen, handleClose: handleOrderClose, handleOpen: handleOrderOpen} = useToggle()
    // const {open: isCreateModalQuantityOpen, handleClose: handleQuantityClose, handleOpen: handleQuantityOpen} = useToggle()
    const classes = useToolbarStyles();
    const {hide, filters} = useInventory();

    const handleSelection = selected => {

        if (selected) {
            dispatch(getItemInventory(filters, selected?.id))
            // console.log(selectedItem?.hasToBuy)
        } else {
            dispatch(getInventory(filters))
            // console.log(selectedItem?.hasToBuy)
        }

        setSelected(selected)
        // console.log(selectedItem?.hasToBuy)
    }


    // const handleDisable = () => hide(selectedItem?.map(one => one?.id))

    const handleCreateOrderModalClosing = () => {
        handleOrderClose()
    }
    // const handleCreateQuantityModalClosing = () => {
    //         handleQuantityClose()
    // }
   
    const exportData = useMemo(() => selectedItem?.map(item => {
        
        const totalShipping = item?.shipping?.map(one => Number(one?.quantity));
        const totalS = (isEmpty(totalShipping) ? [0] : totalShipping)?.reduce((a, b) => a + b)

        const totalPos = item?.pos?.map(one => Number(one?.quantity));
        const totalP = (isEmpty(totalPos) ? [0] : totalPos)?.reduce((a, b) => a + b)
        return ({
            ...item,
            totalP,
            totalS,
            oDekon: (item?.Stock?.Dekon || 0) <= 0,
            oCassablanca: (item?.Stock?.Cassablanca || 0) <= 0,
            sellPrice: item?.SellPrice || item?.Price || item?.NewPrice || 0,
        })


    }), [selectedItem])



    // console.log(exportData) 

    const orders = useMemo(() => {
        // console.log("In USE MEMO = "+ JSON.stringify(selectedItem));
        const products = selectedItem?.map(({id, UPC, ImageUrl,  InternalId, Name, QuantityToBuy,ItemCode, Vendors, VendorsOrderInfo}) => ({
            Id: id,
            UPC,
            ImageUrl,
            InternalId,
            Name,
            Quantity: QuantityToBuy || 0 ,
            ItemCode,
            Vendors,
            VendorsOrderInfo,
        }))
        return {
            Items: products || null,
            ItemIds: products?.map(one => one?.Id) || null,
            Purchaser: null,
            Issuer: null,
            Order: {
                State: "pending",
                Comment: "",
                OrderedAt: new Date(),
                Deadline: new Date()
            }
        }
    }, [selectedItem])

    // console.log(data[])
    // console.log(data)
    // console.log(selectedItem)
    //console.log(selectedItem[0].QuantityToBuy)

    // const handleSubmit = (e) => {
    //     e.preventDefault()

    //     var templateParams = {
    //         name: 'James',
    //         notes: 'Check this out!',
    //         VName: 'GRAND MARCHE',
    //         user_email: 'aalabiboo@gmail.com',
    //         attachments: [
    //             { filename: 'assert/bg.jpg', path: '../../assert/bg.jpg' }
    //         ]
    //     };

    //     // var attachments = [
    //     //     {
    //     //         filename: data.title + ".xlsx",
    //     //         contentType: 'image/jpeg',
    //     //         content: new Buffer.from("base64"),
    //     //     }
    //     // ];


    //     emailjs.send('service_iwp21zr', 'template_qllf7xk', templateParams, 'wMCBY4g_tRljJp2SS')
    //         .then(function (response) {
    //             console.log(response)
    //             // onSubmit && onSubmit(data)
    //             console.log('SUCCESS!', response.status, response.text);
    //         }, function (error) {
    //             console.log('FAILED...', error);
    //         });
    // }



    
    const handleFilter = (action) => {
        dispatch(getInventory(filters, false, 100, null,  action))
    }




    return (
        <section style={{marginBottom: 20}}>

            <Toolbar className={clsx(classes.root, {[classes.highlight]: numSelected > 0})}
                     style={{borderRadius: 20,}}>
                {
                    isNotEmpty(selectedItem) && (
                        <Grid container
                              style={{paddingLeft: 20, paddingRight: 20, justifyContent: 'space-between'}}>
                            <Grid item>
                                <Typography variant={'h6'} style={{paddingTop: 4}}>
                                    {`Séléctionnés :  ${numSelected}`}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Stack direction={'row'}>

                                    <ExcelFile
                                        element={
                                            <Tooltip title={'Exporter en excel'}>
                                                <Button startIcon={<GridOnIcon/>} onclick={ () => { } }>
                                                    Excel
                                                </Button>
                                            </Tooltip>
                                        }
                                    >
                                        
                                        <ExcelSheet data={exportData} name="Reciving">
                                            <ExcelColumn label="Item Code" value="ItemCode"/>
                                            <ExcelColumn label="Nom Produit" value="Name"/>
                                            <ExcelColumn label="Quantity" value="QuantityToBuy"/>
                                        </ExcelSheet>
                                    </ExcelFile>

                                    <Tooltip title={'Commande des produits'}>
                                        <Button startIcon={<AddShoppingCartIcon/>} onClick={handleOrderOpen}>
                                            Commander
                                        </Button>
                                    </Tooltip>
                                </Stack>

                            </Grid>
                        </Grid>
                    )
                }

                {
                    isEmpty(selectedItem) && (
                            <Grid container spacing={2}>
                                <Grid item xs={8}>
                                    
                                <Card>
                                    <CardContent style={{padding: 0}}>

                                        <ItemsAutoComplete value={selected} onChange={handleSelection} minWidth={700}/>

                                    </CardContent>
                                    
                                </Card>
                                </Grid>
                                <Grid item xs={4}>
                                    <VendorSelect setValidationStatus={handleFilter}/>
                                </Grid>
                            </Grid>
                        
                        
                    )
                }

            </Toolbar>

            {
                isCreateModalOpen && (
                    <SendOrdering show={isCreateModalOpen} orderData={orders} onClose={handleCreateOrderModalClosing}/>

                )
            }

        </section>
    )

}